import { render, staticRenderFns } from "./degreeComponent.vue?vue&type=template&id=e9f6d524"
import script from "./degreeComponent.vue?vue&type=script&lang=js"
export * from "./degreeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports